import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

export default function Footer() {
  const currentYear = 2026;

  return (
    <footer className="border-t border-border bg-background py-12">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        {/* Single Row Layout */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo & Copyright */}
          <div className="flex items-center gap-8">
            <Link href="/homepage" className="flex items-center gap-2">
              <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center text-primary-foreground">
                <Icon name="BookOpenIcon" size={20} variant="solid" />
              </div>
              <span className="text-lg font-bold text-foreground">The Modern Job Search Playbook</span>
            </Link>
            <span className="text-sm text-muted-foreground">
              © {currentYear} JobPlaybook. All rights reserved.
            </span>
          </div>

          {/* Links */}
          <div className="flex items-center gap-8 text-sm font-medium text-muted-foreground">
            <Link href="/homepage" className="hover:text-foreground transition-colors">
              Home
            </Link>
            <Link href="/checkout" className="hover:text-foreground transition-colors">
              Buy Now
            </Link>
            <Link href="#" className="hover:text-foreground transition-colors">
              Privacy Policy
            </Link>
            <Link href="#" className="hover:text-foreground transition-colors">
              Terms of Service
            </Link>
          </div>

          {/* Social Icons */}
          <div className="flex items-center gap-4">
            <a
              href="https://twitter.com"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-full bg-secondary flex items-center justify-center text-secondary-foreground hover:bg-primary hover:text-primary-foreground transition-all">

              <Icon name="ShareIcon" size={18} />
            </a>
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-full bg-secondary flex items-center justify-center text-secondary-foreground hover:bg-primary hover:text-primary-foreground transition-all">

              <Icon name="UserGroupIcon" size={18} />
            </a>
          </div>
        </div>
      </div>
    </footer>);

}